import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Paper,
    Divider,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    InputAdornment,
    IconButton,
    Stack,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
    getFirestore,
    collection,
    getDocs,
    doc,
    getDoc,
    deleteDoc,
    where,
    query,
} from "firebase/firestore";
import Fiananceheader from "./Fiananceheader";
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const db = getFirestore();

function Emitaken() {
    const [loans, setLoans] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [openDialog, setOpenDialog] = useState(false);
    const [loanToDelete, setLoanToDelete] = useState(null);
    const navigate = useNavigate();

    const fetchData = async () => {
        setLoading(true);
        try {
            // Fetch all loans
            const loansSnapshot = await getDocs(collection(db, "loans"));
            const loansList = loansSnapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));

            // Fetch customer details for each loan
            const loansWithCustomers = await Promise.all(
                loansList.map(async (loan) => {
                    const customerRef = doc(db, "fianancecustomers", loan.custid);
                    const customerSnap = await getDoc(customerRef);
                    const customerData = customerSnap.exists()
                        ? customerSnap.data()
                        : { name: "Unknown", mobile: "N/A" };
                    return {
                        ...loan,
                        customerName: customerData.name,
                        customerMobile: customerData.mobile,
                    };
                })
            );

            // 1. Sort by loan date ascending
            loansWithCustomers.sort((a, b) => {
                const dateA = a.loandate?.seconds || 0;
                const dateB = b.loandate?.seconds || 0;
                return dateA - dateB;
            });

            // 2. Bring pending (not closed) loans first
            loansWithCustomers.sort((a, b) => {
                if (a.status === "close" && b.status !== "close") return 1;
                if (a.status !== "close" && b.status === "close") return -1;
                return 0;
            });

            setLoans(loansWithCustomers);
        } catch (error) {
            console.error("Error fetching data:", error);
            toast.error("Failed to load loan data.");
        }
        setLoading(false);
    };


    useEffect(() => {
        fetchData();
    }, []);

    const handleDelete = (loan) => {
        setLoanToDelete(loan);
        setOpenDialog(true);
    };

    const confirmDelete = async () => {
        setOpenDialog(false);
        if (!loanToDelete) return;

        try {
            // Delete all associated EMIs first
            const emiQuery = query(collection(db, "loanemis"), where("loanid", "==", loanToDelete.id));
            const emiSnapshots = await getDocs(emiQuery);
            const deleteEmiPromises = emiSnapshots.docs.map(doc => deleteDoc(doc.ref));
            await Promise.all(deleteEmiPromises);

            // Then delete the loan document
            await deleteDoc(doc(db, "loans", loanToDelete.id));

            toast.success("Loan and all associated EMIs deleted successfully!");
            setLoanToDelete(null);
            fetchData(); // Refresh the list
        } catch (error) {
            console.error("Error deleting loan:", error);
            toast.error("Failed to delete loan.");
        }
    };

    const handleViewEmi = (loanId) => {
        // Here you would navigate to a new component/page to display the EMIs
        // For example, using react-router-dom:
        navigate(`/emidetails/${loanId}`);
    };

    const filteredLoans = loans.filter(loan =>
        loan.customerName.toLowerCase().includes(searchQuery.toLowerCase()) ||
        loan.customerMobile.includes(searchQuery)
    );

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Box>
            <Fiananceheader />

            <Box>
                <Typography
                    variant="h4"
                    gutterBottom
                    sx={{
                        fontWeight: 700,
                        textAlign: "center",
                        color: "#1976d2",
                        mb: 3,
                    }}
                >
                    💵 हप्ता वसुली
                </Typography>

                <Box mb={3}>
                    <TextField
                        fullWidth
                        size="small"
                        label="Search by Karjdar Name or Mobile"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        variant="outlined"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>

                {loading ? (
                    <Typography>Loading...</Typography>
                ) : (
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Sr. No.</TableCell>
                                    <TableCell>Actions</TableCell>
                                    <TableCell>कर्जदाराचे नाव </TableCell>
                                    <TableCell>मोबाईल </TableCell>
                                    <TableCell>मूळ कर्ज रक्कम  </TableCell>
                                    <TableCell>दिलेली रक्कम</TableCell>
                                    <TableCell>कर्ज दिनांक </TableCell>
                                    <TableCell>स्टेटस </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredLoans.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={8} align="center">No loans found</TableCell>
                                    </TableRow>
                                ) : (
                                    filteredLoans
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((loan, index) => (
                                            <TableRow key={loan.id}>
                                                <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                                                <TableCell>
                                                    <Stack direction="row" spacing={1}>
                                                        <IconButton
                                                            color="primary"
                                                            size="small"
                                                            onClick={() => handleViewEmi(loan.id)}
                                                        >
                                                            <VisibilityIcon />
                                                        </IconButton>
                                                        <IconButton
                                                            color="error"
                                                            size="small"
                                                            onClick={() => handleDelete(loan)}
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </Stack>
                                                </TableCell>
                                                <TableCell>{loan.customerName}</TableCell>
                                                <TableCell>{loan.customerMobile}</TableCell>
                                                <TableCell>₹{loan.loanamount}</TableCell>
                                                <TableCell>₹{loan.actualamount}</TableCell>
                                                <TableCell>
                                                    {loan.loandate }
                                                </TableCell>
                                                <TableCell>
                                                    <Button
                                                        variant="contained"
                                                        size="small"
                                                        style={{
                                                            backgroundColor: loan.status === "close" ? "green" : "red",
                                                            color: "white",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        {loan.status === "close" ? "Closed" : "Pending"}
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}

                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={filteredLoans.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Box>

            {/* Delete Confirmation Dialog */}
            <Dialog
                open={openDialog}
                onClose={() => setOpenDialog(false)}
            >
                <DialogTitle>Confirm Deletion</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this loan and all of its associated EMIs? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={confirmDelete} color="error" autoFocus>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}

export default Emitaken;